import { render, staticRenderFns } from "./DiagramChooseDiagram.vue?vue&type=template&id=a1355bfa&"
import script from "./DiagramChooseDiagram.vue?vue&type=script&lang=js&"
export * from "./DiagramChooseDiagram.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports